import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { GateWay } from '../gateway.model';

export enum GateWayMibActionTypes {
  UpsertMgtMibTrapList = '[GateWay] Upsert Mgt MibTrap List',
  ReadMgtMibTrapList = '[GateWay] Read Mgt MibTrap List',
  ReadMgtMibTrapListFail = '[GateWay] Read Mgt MibTrap List Fail',
  UpsertMgtMibDetail = '[GateWay] Upsert Mgt Mib Detail',
  ReadMgtMibDetail = '[GateWay] Read Mgt Mib Detail',
  ReadMgtMibDetailFail = '[GateWay] Read Mgt Mib Detail Fail',
  UpsertMibTrapList = '[GateWay] Upsert MibTrap List',
  ReadMibTrapList = '[GateWay] Read MibTrap List',
  ReadMibTrapListFail = '[GateWay] Read MibTrap List Fail',
  UpsertMibDetail = '[GateWay] Upsert Mib Detail',
  ReadMibDetail = '[GateWay] Read Mib Detail',
  ReadMibDetailFail = '[GateWay] Read Mib Detail Fail',
  AddMgtMibDetail = '[GateWay] Add Mgt Mib Detail',
  UpdateMgtMibDetail = '[GateWay] Update Mgt Mib Detail',
  DeleteMgtMibDetail = '[GateWay] Delete Mgt Mib Detail',
  ReadCategoryListByUser = '[GateWay] Read Category List By User',
  UpsertCategoryListByUser = '[GateWay] Upsert Category List By User',
  ReadCategoryListByUserFail = '[GateWay] Read Category List By User Fail',
}

export class ReadMgtMibTrapList implements Action {
  readonly type = GateWayMibActionTypes.ReadMgtMibTrapList;

  constructor(public payload: any = null) {}
}
export class UpsertMgtMibTrapList implements Action {
  readonly type = GateWayMibActionTypes.UpsertMgtMibTrapList;

  constructor(public payload: any) {}
}
export class ReadMgtMibTrapListFail implements Action {
  readonly type = GateWayMibActionTypes.ReadMgtMibTrapListFail;

  constructor(public payload: any = null) {}
}
export class ReadMgtMibDetail implements Action {
  readonly type = GateWayMibActionTypes.ReadMgtMibDetail;

  constructor(public payload: any = null) {}
}
export class UpsertMgtMibDetail implements Action {
  readonly type = GateWayMibActionTypes.UpsertMgtMibDetail;

  constructor(public payload: any) {}
}
export class ReadMgtMibDetailFail implements Action {
  readonly type = GateWayMibActionTypes.ReadMgtMibDetailFail;

  constructor(public payload: any = null) {}
}
export class ReadMibTrapList implements Action {
  readonly type = GateWayMibActionTypes.ReadMibTrapList;

  constructor(public payload: any = null) {}
}
export class UpsertMibTrapList implements Action {
  readonly type = GateWayMibActionTypes.UpsertMibTrapList;

  constructor(public payload: any) {}
}
export class ReadMibTrapListFail implements Action {
  readonly type = GateWayMibActionTypes.ReadMibTrapListFail;

  constructor(public payload: any = null) {}
}
export class ReadMibDetail implements Action {
  readonly type = GateWayMibActionTypes.ReadMibDetail;

  constructor(public payload: any = null) {}
}
export class UpsertMibDetail implements Action {
  readonly type = GateWayMibActionTypes.UpsertMibDetail;

  constructor(public payload: any) {}
}
export class ReadMibDetailFail implements Action {
  readonly type = GateWayMibActionTypes.ReadMibDetailFail;

  constructor(public payload: any = null) {}
}
export class AddMgtMibDetail implements Action {
  readonly type = GateWayMibActionTypes.AddMgtMibDetail;

  constructor(public payload: any = null) {}
}
export class UpdateMgtMibDetail implements Action {
  readonly type = GateWayMibActionTypes.UpdateMgtMibDetail;

  constructor(public payload: any = null) {}
}
export class DeleteMgtMibDetail implements Action {
  readonly type = GateWayMibActionTypes.DeleteMgtMibDetail;

  constructor(public payload: any = null) {}
}
export class ReadCategoryListByUser implements Action {
  readonly type = GateWayMibActionTypes.ReadCategoryListByUser;

  constructor(public payload: any = null) {}
}
export class UpsertCategoryListByUser implements Action {
  readonly type = GateWayMibActionTypes.UpsertCategoryListByUser;

  constructor(public payload: any) {}
}
export class ReadCategoryListByUserFail implements Action {
  readonly type = GateWayMibActionTypes.ReadCategoryListByUserFail;

  constructor(public payload: any = null) {}
}



export type GateWayMibActions =
UpsertMgtMibTrapList
 | ReadMgtMibTrapList
 | ReadMgtMibTrapListFail
 | UpsertMibTrapList
 | ReadMibTrapList
 | ReadMibTrapListFail
 | UpsertMgtMibDetail
 | ReadMgtMibDetail
 | ReadMgtMibDetailFail
 | UpsertMibDetail
 | ReadMibDetail
 | ReadMibDetailFail
 | AddMgtMibDetail
 | UpdateMgtMibDetail
 | DeleteMgtMibDetail
 | UpsertCategoryListByUser
 | ReadCategoryListByUser
 | ReadCategoryListByUserFail
